export default "/assets/website/images/yt.svg?36a12b9c48d447082215d6842c184704";